import React, { useState } from "react";
import randombytes from "randombytes";
import FileUploader from "react-firebase-file-uploader";
import { MDBIcon } from "mdbreact";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";

import alphabet from "../../../../Constants/alphabet";
import { db, storage } from "../../../../fire";

import { capitalize } from "../../../../Utils/strings";
import { clone } from "../../../../Utils/arrObj";

import { Elastic } from "../../../../Services/elastic";

import styles from "./index.module.scss";

const QuestionModal = ({
  setState,
  questionsSelected,
  questionsToAdd,
  defaultValues,
  state,
  open,
  onClose,
  activeMatter,
}) => {
  if (typeof defaultValues === "function") defaultValues = defaultValues();

  const checkReadOnly = () => inputs[3].value === "VF";

  const getAlts = () =>
    inputs[11].alts.map((alt, index) => ({
      value: index,
      name: alphabet.numberLetter[index],
    }));

  const getAnoCorrectType = (ano) => {
    if (typeof ano === "string") return ano;
    else if (typeof ano === "number") return ano.toString();

    return "";
  };

  const [inputs, setInputs] = useState([
    {
      readOnly: true,
      name: "codigo",
      label: "Código",
      value:
        defaultValues?.codigo ||
        `${state?.service?.objetoResultadoRef.codigo.substr(
          0,
          4
        )}-${randombytes(16).toString("hex")}`,
    },
    {
      readOnly: true,
      name: "materia",
      label: "Matéria",
      value: defaultValues?.materia || state?.service?.nomeMateria,
    },
    {
      name: "assunto",
      value:
        defaultValues?.assunto?.join(", ") ||
        state?.service?.objetoResultadoRef?.assunto ||
        "",
    },
    {
      name: "tipo",
      type: "select",
      value: defaultValues?.tipo || "ME",
      alts: [
        {
          value: "ME",
          name: "Multipla Escolha",
        },
        {
          value: "VF",
          name: "Verdadeiro ou Falso",
        },
      ],
    },
    {
      name: "ano",
      value: defaultValues?.ano ? getAnoCorrectType(defaultValues?.ano) : "",
    },
    {
      name: "banca",
      value: defaultValues?.banca || "",
    },
    {
      name: "orgao",
      value: defaultValues?.orgao || "",
    },
    {
      name: "prova",
      value: defaultValues?.prova || "",
    },
    {
      name: "enunciado",
      multiline: true,
      value: defaultValues?.enunciado || "",
    },
    {
      name: "afirmacao",
      multiline: true,
      value: defaultValues?.afirmacao || "",
    },
    {
      name: "image",
      type: "image",
      value: defaultValues?.image || "",
    },
    {
      name: "alternativas",
      type: "array",
      alts: defaultValues?.alternativas || ["", ""],
    },
    {
      name: "respostaCorreta",
      label: "Resposta Correta",
      type: "select",
      value: defaultValues?.respostaCorreta || 0,
      alts: getAlts,
    },
    {
      name: "comentario",
      label: "Comentário",
      value: defaultValues?.comentario || "",
    },
    {
      name: "autorComentario",
      label: "Autor do Comentário",
      value:
        defaultValues?.autorComentario ||
        `${state?.user?.primeiroNome || ""} ${state?.user?.sobrenome || ""}`,
    },
  ]);

  const handleQuestionChange = async (key, value, subKey) => {
    const newValue = clone(inputs);

    switch (key) {
      case "remImg":
        const alertRemove = toast("Excluindo imagem...", {
          type: "info",
          autoClose: false,
        });

        try {
          await storage.refFromURL(newValue[10].value).delete();
        } catch (e) {
          console.error(e);
        }

        toast.dismiss(alertRemove);

        newValue[10].value = "";

        return setInputs(newValue);
      case "addAlt":
      case "remAlt":
      case 11:
        switch (key) {
          case "addAlt":
            newValue[11].alts.push("");
            newValue[12].alts = newValue[11].alts.map((alt, index) => ({
              value: index,
              name: alphabet.numberLetter[index],
            }));
            break;
          case "remAlt":
            if (newValue[12].value === value) {
              toast("Você não pode excluir a alternativa correta!", {
                type: "error",
              });
              return;
            }

            newValue[11].alts.splice(value, 1);
            newValue[12].alts = newValue[11].alts.map((alt, index) => ({
              value: index,
              name: alphabet.numberLetter[index],
            }));
            break;
          default:
            newValue[11].alts[subKey] = value;
            break;
        }

        return setInputs(newValue);
      case 10:
        const alertAdd = toast("Fazendo upload da imagem...", {
          type: "info",
          autoClose: false,
        });

        value = await storage.ref("questoes").child(value).getDownloadURL();

        toast.dismiss(alertAdd);
        break;
      case 12:
        if (isNaN(value)) return;

        value = parseInt(value);
        break;
      case 4:
        if (typeof value === "string") value = value.trim();

        if ((value.length > 0 && isNaN(value)) || value.length > 4) return;
        break;
      case 3:
        if (value === "VF") {
          newValue[8].value =
            "Julgue o conjunto de afirmações a seguir em CERTO ou ERRADO: \r\n";
          newValue[11].alts = ["Certo", "Errado"];
        } else {
          newValue[9].value = "";
        }
        break;
      default:
        break;
    }

    newValue[key].value = value;

    setInputs(newValue);
  };

  const editOrCreateQuestion = async () => {
    const data = {};

    inputs.forEach((input) => {
      if (input.name === "alternativas") {
        data[input.name] = input.alts.slice();
      } else {
        data[input.name] = input.value;
      }
    });

    if (typeof data.ano === "number") data.ano = data.ano.toString();

    const info = { type: "error" };

    if (!["ME", "VF"].includes(data.tipo)) {
      toast(
        'O tipo pode ser apenas "Multipla Escolha" (ME) ou "Verdaeiro ou Falso" (VF)',
        info
      );
      return;
    } else if (data.ano.length > 0 && data.ano.length < 4) {
      toast("Ano inválido.", info);
      return;
    } else if (data.tipo === "ME" && data.enunciado.length < 15) {
      toast(
        "O preenchimento do enunciado é obrigatório. (Minimo de 15 caracteres)",
        info
      );
      return;
    } else if (data.tipo === "VF" && data.afirmacao.length < 15) {
      toast(
        "O preenchimento da afirmação é obrigatório. (Minimo de 15 caracteres)",
        info
      );
      return;
    } else if (!data.assunto || data.assunto.length < 1) {
      toast("O preenchimento do assunto é obrigatório.", info);
      return;
    }

    for (let alt in data.alternativas) {
      if (data.alternativas[alt].length < 1) {
        data.alternativas.splice(alt, 1);
      }
    }

    if (data.alternativas.length < 2 || data.alternativas.length > 6) {
      toast("As questões devem ter entre 2 e 6 alternativas.", info);
      return;
    } else if (
      data.respostaCorreta < 0 ||
      data.respostaCorreta > data.alternativas.length - 1
    ) {
      toast("Resposta Invalida.", info);
      return;
    }

    if (data.ano.trim().length > 0) data.ano = parseInt(data.ano.trim());
    if (
      isNaN(data.ano) ||
      (typeof data.ano === "string" && data.ano.length !== 4)
    )
      data.ano = new Date().getFullYear();
    if (typeof data.ano === "string") parseInt(data.ano);
    if (data.banca.length < 1)
      data.banca = `${state?.user?.primeiroNome || ""} ${
        state?.user?.sobrenome || ""
      }`;
    if (data.orgao.length < 1) data.orgao = "Aprovamais";
    if (data.prova.length < 1) data.prova = state?.service?.nomeMateria;

    data.assunto = data.assunto.split(",").map((item) => item.trim());

    if (
      defaultValues !== null &&
      defaultValues.comentario !== data.comentario
    ) {
      data.autorComentario = `${state?.user?.primeiroNome || ""} ${
        state?.user?.sobrenome || ""
      }`;
    }

    await db.collection("questoes").doc(data.codigo).set(data);

    await Elastic.put(`/questions/_doc/${data.codigo}`, {
      ...data,
      alternativas: JSON.stringify(data.alternativas),
      assunto: JSON.stringify(data.assunto),
    });

    let newQuestionsToAdd;
    const newState = {};

    if (defaultValues === null) {
      const selectedQuestions = clone(questionsSelected) || [];
      selectedQuestions[activeMatter][data.codigo] = data;

      newQuestionsToAdd = clone(questionsToAdd);
      newQuestionsToAdd.unshift(data);

      newState.questionsToAdd = newQuestionsToAdd;
      newState.selectedQuestions = selectedQuestions;

      toast("Questão cadastrada com sucesso!", { type: "success" });
    } else {
      const selectedQuestions = clone(questionsSelected);
      newQuestionsToAdd = clone(questionsToAdd);

      let changedSelectedQuestions = false;
      let changedQuestionsToAdd = false;

      for (const matter in selectedQuestions) {
        for (const code in selectedQuestions[matter]) {
          if (code === data.codigo) {
            selectedQuestions[matter][code] = data;
            changedSelectedQuestions = true;
          }
        }
      }
      for (const position in newQuestionsToAdd) {
        if (newQuestionsToAdd[position].codigo === data.codigo) {
          newQuestionsToAdd[position] = data;
          changedQuestionsToAdd = true;
        }
      }

      if (changedSelectedQuestions) {
        newState.selectedQuestions = selectedQuestions;
      }
      if (changedQuestionsToAdd) {
        newState.questionsToAdd = newQuestionsToAdd;
      }
    }

    setState(newState);
    onClose();
  };

  return (
    <Dialog
      aria-labelledby="form-dialog-title"
      open={open}
      onClose={() => onClose}
    >
      <DialogTitle id="form-dialog-title">
        {defaultValues !== null ? "Editar" : "Adicionar"} Questão
      </DialogTitle>

      <DialogContent>
        {inputs.map((info, key) => {
          switch (info.type) {
            case "select":
              if (typeof info.alts === "function") info.alts = info.alts();

              return (
                <div key={key}>
                  <InputLabel id={`${info.name}-label`}>
                    {info.label || capitalize(info.name)}
                  </InputLabel>
                  <Select
                    fullWidth
                    margin="dense"
                    name={info.name}
                    labelid={`${info.name}-label`}
                    value={info.value}
                    label={info.label || info.name.toUpperCase()}
                    onChange={(e) => handleQuestionChange(key, e.target.value)}
                  >
                    {info.alts.filter((a) =>
                      typeof a === "string" ? a.length > 0 : true
                    ).length > 0 &&
                      info.alts.map((alt, key) => (
                        <MenuItem key={key} value={alt.value}>
                          {alt.name}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              );
            case "image":
              return (
                <div key={key} className={styles["question-imagem"]}>
                  <InputLabel>{info.label || capitalize(info.name)}</InputLabel>
                  <div>
                    {!info.value && (
                      <FileUploader
                        name={info.name}
                        randomizeFilename
                        storageRef={storage.ref("questoes")}
                        onUploadSuccess={(filename) =>
                          handleQuestionChange(key, filename)
                        }
                      />
                    )}
                  </div>
                  {info.value && (
                    <div className={styles["imagem"]}>
                      <img src={info.value} alt={info.value} />
                      <div onClick={() => handleQuestionChange("remImg")}>
                        <MDBIcon icon="times" />
                      </div>
                    </div>
                  )}
                </div>
              );
            case "array":
              return (
                <div key={key}>
                  <InputLabel>{info.label || capitalize(info.name)}</InputLabel>
                  <div>
                    <div>
                      {info.alts.map((alt, subKey) => (
                        <div key={subKey} className={styles["alt"]}>
                          <div>
                            <div
                              className={
                                subKey === inputs[12].value
                                  ? styles["correta"]
                                  : ""
                              }
                            >
                              {alphabet.numberLetter[subKey]}
                            </div>
                          </div>
                          <TextField
                            multiline
                            disabled={checkReadOnly()}
                            readOnly={checkReadOnly()}
                            margin="dense"
                            style={{ width: "80%" }}
                            name={info.name}
                            label={info.label || capitalize(info.name)}
                            value={alt}
                            onChange={(e) =>
                              checkReadOnly()
                                ? false
                                : handleQuestionChange(
                                    key,
                                    e.target.value,
                                    subKey
                                  )
                            }
                          />
                          <div>
                            {![0, 1].includes(subKey) && (
                              <div
                                onClick={() =>
                                  handleQuestionChange("remAlt", subKey)
                                }
                              >
                                <MDBIcon icon="times" />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    {!checkReadOnly() && info.alts.length < 6 && (
                      <div className={styles["add-alt-btn"]}>
                        <div onClick={(e) => handleQuestionChange("addAlt")}>
                          <MDBIcon icon="plus" />
                          <span> Adicionar Alternativa</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            default:
              const readOnly =
                info.name === "enunciado" ? checkReadOnly() : false;

              if (info.name === "afirmacao" && !checkReadOnly()) return;

              return (
                <TextField
                  fullWidth
                  multiline
                  key={key}
                  disabled={info.readOnly || readOnly}
                  readOnly={info.readOnly || readOnly}
                  margin="dense"
                  name={info.name}
                  label={info.label || capitalize(info.name)}
                  value={info.value}
                  onChange={(e) =>
                    info.readOnly || readOnly
                      ? false
                      : handleQuestionChange(key, e.target.value)
                  }
                />
              );
          }
        })}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button color="primary" onClick={() => editOrCreateQuestion()}>
          {defaultValues !== null ? "Editar" : "Adicionar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuestionModal;
